// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nk_D","label":"styles_label__2_StX"};